import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import ComponentTransparentDetail from '../../components/component_transparent/ComponentTransparentDetail';
import { defaultRejectHandler } from '../../utils/utility';
import { createComponentTransparent, createComponentWithMaterials } from '../../redux/component_transparent/component_actions';

class ComponentTransparentCreateModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.componentDetail = undefined;
    this.materialsToComponent = undefined;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.component !== nextProps.component && nextProps.show) {
      this.props.getComponent(nextProps.component.id);
    }
  }

  onSaveHandler() {
    const newComponent = this.componentDetail.getWrappedInstance().getWrappedInstance().getComponentData();
    this.props.createComponentWithMaterials(newComponent,this.materialsToComponent)
  }

  render() {
    const { isCreating, errorMessage, componentDetail, createComponent, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('create transparent component')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ComponentTransparentDetail
            component={componentDetail}
            ref={ref => (this.componentDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            materialsToComponent={ref => (this.materialsToComponent = ref)}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="component-transparent-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {isCreating ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.component.transparent.errorMessage,
  isCreating: state.component.transparent.isCreating,
  componentDetail: props.component && state.component.transparent.components[props.component.id],
});

const mapDispatchToProps = dispatch => ({
  createComponent: component =>
    defaultRejectHandler(
      dispatch(
        createComponentTransparent(component.name, component.heat_dissipation_id, component.description, component.image)
      ),
    ),
  createComponentWithMaterials: (component, materials) =>
    defaultRejectHandler(
      dispatch(
        createComponentWithMaterials(
          component.name,
          component.heat_dissipation_id,
          component.description,
          component.image,
          materials,
        )
      )
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ComponentTransparentCreateModal),
);



// WEBPACK FOOTER //
// ./src/modal/component_transparent/ComponentTransparentCreateModal.js